// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_37-lec9","container":"_1IWXq8E","container__notLoading":"_2Yqh5U6","container__withError":"Bb4CiTc"};


//////////////////
// WEBPACK FOOTER
// ./template/components/CountrySelector/Container.css
// module id = ./template/components/CountrySelector/Container.css
// module chunks = client.sitechrome